/*import { graphConfig } from "../../../config";
import { msalInstance } from "../../../index";

const scopes = {
    scopes: ["User.Read"]
};

export async function callMsGraph() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...scopes,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}*/




// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getHeaders } from '../silentAuth'
import { graphConfig } from "../../config";

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */

const scopes = {
    scopes: ["User.Read"]
};

// Define a service using a base URL and expected endpoints
export const graphApi = createApi({
  reducerPath: 'graphApi',
  baseQuery: fetchBaseQuery({
    baseUrl: graphConfig.graphMeEndpoint,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(scopes, headers); }
  }),
  endpoints: (builder) => ({
    getUser: builder.query<any, void>({
      query: () => `/me`,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUserQuery,
  useLazyGetUserQuery
} = graphApi
